import { DeserializedStore } from '@/src/lib/store/types';

export function getCountryNameFromCode(code: string, store: DeserializedStore): string | undefined {
  return store.countries.find((country) => country.iso2Code === code)?.name;
}

export function getRegionNameFromCode(
  regionCode: string,
  store: DeserializedStore,
  countryCode?: string,
): string | undefined {
  if (countryCode) {
    const country = store.countries.find((country) => country.iso2Code === countryCode);
    if (country) {
      const region = country.regions.find((region) => region.iso2Code === regionCode);
      if (region) {
        return region.name;
      }
    }
  }

  for (const country of store.countries) {
    const foundRegionName = country.regions.find((region) => region.iso2Code === regionCode)?.name;
    if (foundRegionName) {
      return foundRegionName;
    }
  }
  return undefined;
}
